
    const data = {"name":"src/core/icons/content-save-minus","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.81c-.36-.62-.61-1.3-.73-2H12c-1.66 0-3-1.34-3-3s1.34-3 3-3c.68 0 1.34.23 1.87.65A6.015 6.015 0 0 1 18 12c1.05 0 2.09.28 3 .81V7l-4-4m-2 6H5V5h10v4m-1 8v2h8v-2h-8Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            